import React from "react";
import OptionalTextInput from "./OptionalTextInput";
import { useSemanticUiInputRef } from "utilities/hookutils";

interface Props {
  value: string
  onChange: (newValue: string) => void


  onBlur?: () => void
  onFocus?: () => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  disabled?: boolean
  placeholder?: string
  loading?: boolean
  hasError?: boolean;
  innerRef?: ReturnType<typeof useSemanticUiInputRef>;
}

export const GlobalLocationNumberInput = (props: Props) => {

  const onChange = (newvalue: string) => {
    // Ensure only digits are entered
    const digitsOnly = newvalue.replace(/\D/g, "");
    props.onChange(digitsOnly);
  }

  const onPaste = (e: React.ClipboardEvent) => {
    const text: string = e.clipboardData.getData("text").trim();
    const digitsOnly = text.replace(/\D/g, "").substring(0, serverReference.constants.company.exactGlobalLocationNumberLength);
    props.onChange(digitsOnly);
  };

  return <OptionalTextInput
    maxLength={serverReference.constants.company.exactGlobalLocationNumberLength}
    value={props.value}
    onChange={onChange}
    onPaste={onPaste}
    onBlur={props.onBlur}
    onFocus={props.onFocus}
    onEnter={props.onEnter}
    onEsc={props.onEsc}
    focusOnMount={props.focusOnMount}
    disabled={props.disabled}
    placeholder={props.placeholder}
    loading={props.loading}
    hasError={props.hasError}
    innerRef={props.innerRef}
  />
}